<template>
    <div class="m15 page_logo" ref="body" id="protecao" style="page-break-before: always;">
        <div class="site"></div>
        <hr />
        <h4 class="simulator-title loaded">Resumo de Necessidade de Proteção</h4>

        <div class="row" >
            <div class="col l3"></div>
            <div class="col l6 s12">
                <table class="striped print-table print-table-striped print-table-big" >
                    <thead>
                        <tr>
                            <th scope="col">NECESSIDADES</th>
                            <th scope="col">CAPITAL SEGURADO NECESSÁRIO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="resumo.necessidade_segurado_items.patrimonio">
                            <td data-label="NECESSIDADES">
                                <b>Planejamento sucessório</b>
                            </td>
                            <td data-label="CAPITAL SEGURADO NECESSÁRIO">
                                {{ resumo.necessidade_segurado_items.patrimonio | dinheiro }}
                            </td>
                        </tr>
                        <tr v-if="resumo.necessidade_segurado_items.obrigacao_financeira">
                            <td data-label="NECESSIDADES">
                                <b>Obrigações financeiras (dívidas e ônus)</b>
                            </td>
                            <td data-label="CAPITAL SEGURADO NECESSÁRIO">
                                {{ resumo.necessidade_segurado_items.obrigacao_financeira | dinheiro }}
                            </td>
                        </tr>
                        <tr v-if="resumo.necessidade_segurado_items.padrao_vida > 0">
                            <td data-label="NECESSIDADES">
                                <b>Padrão de vida familiar {{ anos_protecao_familia }} ano(s)</b>
                            </td>
                            <td data-label="CAPITAL SEGURADO NECESSÁRIO">
                                {{ resumo.necessidade_segurado_items.padrao_vida | dinheiro }}</td>
                        </tr>
                        <tr v-if="resumo.necessidade_segurado_items.educacao_filhos">
                            <td data-label="NECESSIDADES">
                                <b>Educação dos filhos</b>
                            </td>
                            <td data-label="CAPITAL SEGURADO NECESSÁRIO">
                                {{ resumo.necessidade_segurado_items.educacao_filhos | dinheiro }}</td>
                        </tr>
                        <tr v-if="resumo.necessidade_segurado" class="print-text-primary">
                            <td data-label="NECESSIDADES">
                                <b class="valor_total">Total de cobertura necessária</b>
                            </td>
                            <td class="valor_total" data-label="CAPITAL SEGURADO NECESSÁRIO">
                                {{ resumo.necessidade_segurado | dinheiro }}</td>
                        </tr>
                        <tr v-if="resumo.seguro">
                            <td data-label="NECESSIDADES">
                                <b>Seguro atual existente</b>
                                <p class="hint">Faz-se necessário avaliar coberturas do seguro atual</p>
                            </td>
                            <td data-label="CAPITAL SEGURADO NECESSÁRIO">
                                {{resumo.seguro | dinheiro}}
                            </td>
                        </tr>
                        <tr v-if="necessidade_comp">
                            <td data-label="NECESSIDADES">
                                <b>Necessidade de complementação</b>
                            </td>
                            <td data-label="CAPITAL SEGURADO NECESSÁRIO">
                                {{ necessidade_comp | dinheiro }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col l3"></div>
        </div>

        <div class="row m5">
            <div class="col l3"></div>
            <div class="col l6 s12">
                <table class="striped print-table print-table-striped print-table-big" v-if="fonte_renda_autonomo !== null">
                    <thead>
                        <tr>
                            <th scope="col">NECESSIDADES</th>
                            <th scope="col">RENDA MENSAL SEGURADA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td data-label="NECESSIDADES">
                                <b>Renda mensal (temporário ou definitivo)</b>
                            </td>
                            <td data-label="CAPITAL SEGURADO NECESSÁRIO">{{ fonte_renda_autonomo | dinheiro}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col l3"></div>
        </div>

        <div class="texto"  v-if="empresa_selecionada && ['mais previdencia', 'mais previdência'].includes(empresa_selecionada.empresa_nome_fantasia.toLowerCase())">
            Reforçando que através da Mais Previdência você tem condições diferenciadas para
            as necessidades de proteção através da Icatu Seguros, uma das maiores seguradoras
            do mercado.
        </div>
        <div v-else-if="empresa_selecionada && empresa_selecionada.empresa_nome_fantasia.toLowerCase().includes('oabprev')" class="texto">
            Reforçamos a informação de que através da OABPrev MG você tem acesso as melhores condições de proteção, pecúlio por morte, pecúlio por invalidez e seguro de renda por incapacidade temporária disponíveis no mercado.
        </div>
    </div>
</template>

<script>
import { utils } from "../relatorios/mixins/index";
export default {
    name: 'ResumoProtecao',
    mixins: [utils],

    props: {
        cliente: Object ,
        empresa_selecionada: Object,
        resumo: Object,
    },

    computed: {
        necessidade_comp () {
            return this.resumo.necessidade_segurado - this.resumo.seguro
        },
        seguroAtual() {
            const seguro = parseFloat(this.resumo.seguro);
            return this.real(seguro)
        },
        sucessorio () {
            const sucessorio = parseFloat(this.resumo.necessidade_segurado_items.patrimonio)
            return this.real(sucessorio)
        },

        fonte_renda_autonomo() {

            const fonte = this.cliente.fontes_renda.find(item => item.tipo == 'T')

            if (fonte && fonte.autonomo) {
                return (fonte.rendimento_mensal * fonte.autonomo * 0.01);
            }


            return null;

        },

        anos_protecao_familia() {
            if (this.cliente.padrao_vida) {
                return parseInt(this.cliente.padrao_vida.anos_protecao_familia);
            }
        }
    },

    methods: {
        plot() {
            return this.$refs.body.outerHTML;
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.block{
    width: 300px;
    margin-left: 120px;
    display: contents;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
.valor_total{
    color: var(--color-primary);
}
th{
    text-align: center;
}
td{
    text-align: center;
}
.hint{
    font-size: 11px;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 300px;
        margin-left: 25px;
        display: block;
    }
}
@media screen and (max-width: 600px) {
    table {
      border: 0;
    }

    table caption {
      font-size: 1.3em;
    }

    table thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    table tr {
      border-bottom: 3px solid #ddd;
      display: block;
      margin-bottom: .625em;
    }

    table td {
      border-bottom: 1px solid #ddd;
      display: block;
      font-size: .8em;
      text-align: right;
    }

    table td::before {
      /*
      * aria-label has no advantage, it won't be read inside a table
      content: attr(aria-label);
      */
      content: attr(data-label);
      float: left;
      font-weight: bold;
      text-transform: uppercase;
      color: var(--color-primary);
    }

    table td:last-child {
      border-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/ResumoProtecao.vue